import ACTIONS from '../actions.js'

export function templateReducer(state, action) {
  switch (action.type) {
    case ACTIONS.SET_TEMPLATE_DOCUMENTS:
      return { ...state, templateDocuments: action.value }

    case ACTIONS.SET_REQUEST_TEMPLATE:
      return {
        ...state,
        selectedRequestTemplate: action.value,
        selectedDocuments: [],
        otherInputs: [''],
        perDocumentDates: {},
        perOtherInputDates: {},
        specialInstructions: '',
        dateRange: { from: null, to: null },
        dueDate: null,
        assignees: [
          { firstname: '', lastname: '', username: '', createContact: false },
        ],
      }

    case ACTIONS.SET_DATE_RANGE:
      return {
        ...state,
        dateRange: { ...state.dateRange, [action.key]: action.value },
      }

    case ACTIONS.SET_DUE_DATE:
      return { ...state, dueDate: action.value }

    case ACTIONS.TOGGLE_DOCUMENT_SELECTION: {
      const id = action.id
      const already = state.selectedDocuments.includes(id)
      return {
        ...state,
        selectedDocuments: already
          ? state.selectedDocuments.filter(d => d !== id)
          : [...state.selectedDocuments, id],
      }
    }

    case ACTIONS.ADD_OTHER_INPUT:
      return { ...state, otherInputs: [...state.otherInputs, ''] }

    case ACTIONS.UPDATE_OTHER_INPUT:
      return {
        ...state,
        otherInputs: state.otherInputs.map((val, idx) =>
          idx === action.index ? action.value : val,
        ),
      }

    case ACTIONS.REMOVE_OTHER_INPUT:
      return {
        ...state,
        otherInputs: state.otherInputs.filter((_, idx) => idx !== action.index),
      }

    case ACTIONS.SET_PER_DOCUMENT_DATE:
      return {
        ...state,
        perDocumentDates: {
          ...state.perDocumentDates,
          [action.docId]: {
            ...state.perDocumentDates[action.docId],
            [action.field]: action.value,
          },
        },
      }

    case ACTIONS.SET_PER_OTHER_INPUT_DATE:
      return {
        ...state,
        perOtherInputDates: {
          ...state.perOtherInputDates,
          [action.index]: {
            ...state.perOtherInputDates[action.index],
            [action.field]: action.value,
          },
        },
      }

    case ACTIONS.SET_SPECIAL_INSTRUCTIONS:
      return { ...state, specialInstructions: action.value }

    case ACTIONS.ADD_ASSIGNEE:
      return {
        ...state,
        assignees: [
          ...state.assignees,
          { firstname: '', lastname: '', username: '', createContact: false },
        ],
      }

    case ACTIONS.UPDATE_ASSIGNEE:
      return {
        ...state,
        assignees: state.assignees.map((a, i) =>
          i === action.index ? action.assignee : a,
        ),
      }

    case ACTIONS.UPDATE_ASSIGNEE_FIELD:
      return {
        ...state,
        assignees: state.assignees.map((assignee, i) =>
          i === action.index
            ? { ...assignee, [action.field]: action.value }
            : assignee,
        ),
      }

    case ACTIONS.REMOVE_ASSIGNEE:
      return {
        ...state,
        assignees: state.assignees.filter((_, i) => i !== action.index),
      }

    default:
      return state
  }
}

export default templateReducer
